import { Component, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

import { ConfigureService } from '@app/configure/services/configure.service';
import { HelperService } from '@app/core/services/helper.service';

@Component({
	selector: 'cng-step-header',
	templateUrl: './step-header.component.html',
	styleUrls: ['./step-header.component.less'],
})
export class StepHeaderComponent implements OnInit, OnDestroy {
	@Input() current_step_key: string = '';
	@Input() location: string = '';

	@Output() jump: EventEmitter<string> = new EventEmitter<string>();

	steps: any = this.configure_service.configure_data.steps;
	steps_order: string[] = this.configure_service.configure_data.steps_order;
	step_mode: string = this.configure_service.getStepMode();
	latest_step: string = this.configure_service.configure_data.meta.latest_step;
	menu_open: boolean = false;
	lte_sm: boolean = false;
	current_step_index: number = this.configure_service.configure_data.steps_order.indexOf(this.current_step_key) || 0;

	enquiry_hash: string;

	destroyed$: Subject<boolean> = new Subject<boolean>();

	constructor(private configure_service: ConfigureService, private helper_service: HelperService) {}

	ngOnInit(): void {
		this.checkScreenWidth();
		this.configure_service.configure_data$.pipe(takeUntil(this.destroyed$)).subscribe((configure_data: any) => {
			this.latest_step = configure_data.meta.latest_step;
			this.steps = this.configure_service.configure_data.steps;
			this.steps_order = this.configure_service.configure_data.steps_order;
			this.current_step_index = configure_data.steps_order.indexOf(this.current_step_key);
		});
	}

	@HostListener('window:resize')
	checkScreenWidth(): void {
		this.lte_sm = this.helper_service.isScreenWidth('<=', 'sm');
	}

	jumpTo(step_key: string): void {
		this.menu_open = false;
		setTimeout(
			() => {
				this.jump.emit(step_key);
			},
			this.helper_service.isScreenWidth('<=', 'sm') ? 200 : 0
		);
	}

	ngOnDestroy(): void {
		this.destroyed$.next(true);
	}
}
